import FolderCopy from "@mui/icons-material/FolderCopy";
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { formatPersonName } from "utility/formatters";

export default function UserGrantItem({
  userGrant,
  producer,

  isSelected,
  onClick,
}) {
  return (
    <>
      <ListItem>
        <ListItemButton
          onClick={() => onClick && onClick(userGrant || producer)}
          sx={(theme) => ({
            p: 2,
            ...(isSelected && {
              backgroundImage: `linear-gradient(90deg, ${theme.palette.colors.brandLightGreen} 0%, ${theme.palette.colors.brandMediumOrange} 100%)`,
            }),
          })}
        >
          <ListItemIcon>
            <FolderCopy />
          </ListItemIcon>
          <ListItemText
            primary={
              formatPersonName(producer) ||
              producer?.business_name ||
              userGrant?.producer_description ||
              userGrant?.producer_email
            }
          />
        </ListItemButton>
      </ListItem>
    </>
  );
}
